/* =========================================================================
 * PRECHECKOUT
 * ========================================================================= */
console.log("Carrito script cargado...");

/* -------------------------------------------------------------------------
 * 1. CONSTANTES Y ALMACENAMIENTO LOCAL
 * ------------------------------------------------------------------------- */
const CUSTOMER_KEY = "customerData";

function setCustomerData(field, value) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    data[field] = value;
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}

function getCustomerData(field) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    return data[field] || null;
}

function getAllCustomerData() {
    return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}

function clearCustomerData() {
    localStorage.removeItem(CUSTOMER_KEY);
}

function setLocalStorageCustomerData() {
    setCustomerData("firstName", $("#enova-billing-name").val());
    setCustomerData("lastName", $("#enova-billing-lastName").val());
    setCustomerData("email", $("#enova-billing-email").val());
    setCustomerData("phone", $("#enova-billing-telefono").val());
    setCustomerData("documentType", $("#enova-billing-documento-type").val());
    setCustomerData("documentNumber", $("#enova-billing-documento-number").val());

    setCustomerData("shippingMethodType", $('input[name="enova-despacho-tipo"]:checked').val());
    setCustomerData("shippingMethod", $('input[name="enova-despacho"]:checked').val());
    setCustomerData("region", $("#enova-carrito-block-despacho-shipping__departamento").val());
    setCustomerData("city", $("#enova-carrito-block-despacho-shipping__provincia").val());
    setCustomerData("locality", $("#enova-carrito-block-despacho-shipping__distrito").val());

    setCustomerData("address", $("#enova-despacho-direccion").val());
    setCustomerData("reference", $("#enova-despacho-referencia").val());

    setCustomerData("billingType", $('input[name="enova-billing-doc"]:checked').val());
    setCustomerData("ruc", $("#enova-billing-doc-ruc").val() || "");
    setCustomerData("companyName", $("#enova-billing-doc-razonsocial").val() || "");
    setCustomerData("loaded", false);
}

function setInitCustomerData() {
    const customerData = getAllCustomerData();
    if (Object.keys(customerData).length === 0) {
        if (window.ShopifyCustomer && window.ShopifyCustomer.logged_in) {
            $("#enova-billing-name").val(window.ShopifyCustomer.firstName);
            $("#enova-billing-lastName").val(window.ShopifyCustomer.lastName);
            $("#enova-billing-email").val(window.ShopifyCustomer.email);
        }
    } else {
        $("#enova-billing-name").val(getCustomerData("firstName"));
        $("#enova-billing-lastName").val(getCustomerData("lastName"));
        $("#enova-billing-email").val(getCustomerData("email"));
        $("#enova-billing-telefono").val(getCustomerData("phone"));
        $("#enova-billing-documento-type").val(getCustomerData("documentType"));
        $("#enova-billing-documento-number").val(getCustomerData("documentNumber"));
        
        $(`input[name="enova-despacho"][value="${getCustomerData("shippingMethod")}"]`).prop('checked', true).trigger('change');
        
        if ($('input[name="enova-despacho"]:checked').val() == 'delivery') {
            $("#enova-despacho-shipping").css("display", "block");
            $("#enova-despacho-direccion").val(getCustomerData("address"));
            $("#enova-despacho-referencia").val(getCustomerData("reference"));
        } else {
            $("#enova-despacho-shipping").css("display", "none");
            $("#enova-despacho-recojo-tienda").css("display", "block");
        }
    
        $(`input[name="enova-billing-doc"][value="${getCustomerData("billingType")}"]`).prop('checked', true).trigger('change');
        
        if (getCustomerData("billingType") == "factura") {
            $("#enova-billing-doc").css("display", "block");
            $("#enova-billing-doc-ruc").val(getCustomerData("ruc"));
            $("#enova-billing-doc-razonsocial").val(getCustomerData("companyName"));
        }
    }
}


/* -------------------------------------------------------------------------
 * 2. STOREFRONT API
 * ------------------------------------------------------------------------- */
async function populate(scope = "departaments", options) {
    try {
        let countrySelected = options.country;
        let departamentoSelected = options.departament;
        let provinceSelected = options.district;
        let urlBuilder = null;

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`;
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`;
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`;
        }

        let departamentos = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
            "method": "GET",
            "headers": { 'Content-Type': 'application/json' }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active;
                } else {
                    return item;
                }
            });
            return filteredResponse;
        })
        .then((response) => {
            console.log("response", response);
            return response;
        })
        .catch(error => console.error('Error:', error));

        console.log("UBIGEOS - ", scope, departamentos);
        return departamentos;

    } catch(err) {
         console.log("err", err);
         return err;
    }
}
 
async function getPickUpShopList(filter_zona = null) {
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>");

    let shopsList = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation?scope=shop-addresses`, {
        "method": "GET",
        "headers": { 'Content-Type': 'application/json' }
    })
    .then((res) => res.json())
    .then((response) => response)
    .catch(error => console.error('Error:', error));

    console.log("lista de tiendas", shopsList);

    let list_stores_filtered = [];
    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona;
        });
        shopsList = list_stores_filtered;
    }

    let templateBlockStoreList = "";
    for(let store of shopsList) {
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.code}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.code}" data-departamento="${store.department}" data-provincia="${store.province}" data-distrito="${store.distrit}" data-ubigeo="${store.ubigeo}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name}</h3>
                    <p class="enova-tienda-direccion">${store.address}</p>
                    <p class="enova-tienda-complement">${store.complement}</p>
                </div>
            </label>
        `;
        templateBlockStoreList += templateItemElement;
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList);

    setTimeout(() => {
        setStoresEventClick();
    }, 300);

    return shopsList;
}

async function getTotalCart(format = null) {
    let totalCart = 0
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
    const dataCart = await responseCart.json();
    return dataCart.total_price / 100
}

/**
 * Atributos que el precheckout inyecta en cada línea y que el callback de envío
 * (POST /apolo-shipping-shopify-ilahui) lee desde `item.properties`.
 * Ganan sobre cualquier property del carrito con el mismo key.
 */
const RESERVED_LINE_ATTRIBUTES = ["tipo de despacho", "shipping method", "ubigeo", "peso", "sku"];

// Storefront API corta los valores de atributo en 255 caracteres. Si uno se pasa,
// checkout.create falla completo y el cliente no puede comprar, así que preferimos
// recortar y avisar en consola antes que perder la venta.
const ATTRIBUTE_VALUE_MAX = 255;

function truncateAttributeValue(key, value) {
    let asText = String(value);
    if (asText.length <= ATTRIBUTE_VALUE_MAX) return asText;
    console.warn(`[precheckout] atributo "${key}" recortado: ${asText.length} > ${ATTRIBUTE_VALUE_MAX} caracteres`);
    return asText.slice(0, ATTRIBUTE_VALUE_MAX - 3) + "...";
}

/**
 * Properties del carrito -> attributes del checkout.
 * Sin esto se pierden pd_personalization_id, el preview y toda la data del
 * personalizador, y producción no sabe qué imprimir.
 */
function getLineItemPropertiesAsAttributes(properties) {
    if (!properties) return [];

    let attributes = [];
    for (let key in properties) {
        if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
        if (RESERVED_LINE_ATTRIBUTES.indexOf(key) !== -1) continue;

        let value = properties[key];
        if (value === null || value === undefined || value === "") continue;

        attributes.push({ key: key, value: truncateAttributeValue(key, value) });
    }
    return attributes;
}

async function getResponseCartItems(format = null) {
    let carritoItems = [];
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const dataCart = await responseCart.json();

    for(let item of dataCart.items) {
        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`;
        
        function utf8_to_b64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
            
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo");
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val();
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val();

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: [
                ...getLineItemPropertiesAsAttributes(item.properties),
                {key: "_tipo de despacho", value: getDespacho},
                {key: "_shipping method", value: getShippingMethod},
                {key: "_ubigeo", value: String(getUbigeoSelected) },
                {key: "_peso", value: String(item.grams) },
                {key: "_sku", value: String(item.sku) },
                {key: "_final_price", value: String(item.final_price) }
            ]
        };

        if(format) {
            let isShipping = item.grams && item.grams > 0 ? true : false;
            lineItemsToAdd['requires_shipping'] = isShipping;    
            lineItemsToAdd['requires_shipping'] = true; // FORCE ALL FISICAL ITEMS  - SHIPPING
        }
        carritoItems.push(lineItemsToAdd);
    }
    return carritoItems;
}


async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        async function createCheckout(client, inputCheckout) {
            let inputData = {
                email: inputCheckout.email,
                lineItems: inputCheckout.lineItems,
                shippingAddress: inputCheckout.shippingAddress,
                customAttributes: inputCheckout.customAttributes,
            };

            let checkoutResponse = await client.checkout.create(inputData).then((checkout) => {
                return checkout;
            });
            return checkoutResponse;
        }
    
        function getCartAttributesFormatted(cartAttributes) {
            let checkoutattrs = [];
            for(let cartKey in cartAttributes.attributes) {
                let objectAttributes = {
                    key: cartKey,
                    value: cartAttributes.attributes[cartKey]
                };
                checkoutattrs.push(objectAttributes);
            }
            return checkoutattrs;
        }
    
        function checkoutUpdateAddress(shippingAddress) {
            function getProvinceCorrelatives (province) {
                switch(province) {
                    case "Lima":
                    case "LIMA":
                        return "PE-LMA";
                    default:
                        return province;
                }
            }
    
            console.log("shippingAddress", shippingAddress);
    
            const shippingAddressObj = {
                address1: shippingAddress['direccion'], 
                address2: shippingAddress['referencia'], 
                firstName: shippingAddress['nombre'], 
                lastName: shippingAddress['apellido'], 
                company:  shippingAddress['comprobante de pago'] === "factura" ? shippingAddress['ruc'] : shippingAddress['documento identidad'], 
                phone: shippingAddress['telefono'], 
                country: shippingAddress['pais'], 
                province: getProvinceCorrelatives(shippingAddress['departamento']),
                city: shippingAddress['distrito'],
                zip: shippingAddress['ubigeo']
            };

            console.log("shippingAddressObj", shippingAddressObj);
            return shippingAddressObj;
        }

        let client = ShopifyBuy.buildClient({
            domain: '/ilahuiperu.com',
            storefrontAccessToken: '2891c4de74c38cc6f5edae226bc74f0f'
        });
        
        let carritoItemsList = await getResponseCartItems();
        console.log("carritoItemsList", carritoItemsList);
        
        let checkoutAtributesList = getCartAttributesFormatted(cartAttributes);
        let checkoutAddressParsed2Checkout = checkoutUpdateAddress(cartAttributes.attributes);

        let inoutCheckout2Create = {
            email: cartAttributes.attributes.email,
            lineItems: carritoItemsList,
            shippingAddress: checkoutAddressParsed2Checkout,
            customAttributes: checkoutAtributesList
        };

        console.log("checkout create", inoutCheckout2Create);

        let checkout = await createCheckout(client, inoutCheckout2Create);
    
        if(!(checkout && checkout.id && checkout.email && checkout.shippingAddress)) {
            throw "error create checkout";
        } else {
            console.log("CHECKOUT", checkout);
            return ({checkout: checkout });
        }
        
    } catch(err) {
        console.log("error", err);
        checkoutButtonLoader(false);
        document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos de los productos no estan disponible. Porfavor volver a intentar en unos minutos!";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return err;
    }
}


/* -------------------------------------------------------------------------
 * 3. LÓGICA Y REGLAS DE VALIDACIÓN
 * ------------------------------------------------------------------------- */
function validateDeliveryForm(objectForm) {
    let validated = true;
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key]);
        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false;
        }
    }
    return validated;
}

function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping;
        if(isShipping) {
            isCarritoReadyForShipping = true;
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true;
    }

    return isCarritoReadyForShipping;
}

function setLogistictProgrammedDateRules() {
    const inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
    if (!inputFecha) return;

    const hoy = new Date();
    const horaActual = hoy.getHours();
    let horarioCorte = 21; // 9PM
    
    if (hoy.toLocaleDateString() == "31/12/2025") { horarioCorte = 12; }
    if (hoy.toLocaleDateString() == "24/12/2025") { horarioCorte = 12; }
    
    const feriados = [
        "30-08-2025", "31-08-2025", "01-11-2025", "02-11-2025", "08-12-2025",
        "09-12-2025", "10-12-2025", "24-12-2025", "25-12-2025", "28-12-2025",
        "01-01-2026", "10-01-2026",
    ];

    function esFeriado(fecha) {
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const anio = fecha.getFullYear();
        const fechaStr = `${dia}-${mes}-${anio}`;
        if (dia === '05' && mes === '08' && anio === '2025') return false;
        return feriados.includes(fechaStr);
    }

    inputFecha.innerHTML = '';
    let ubigeo = '150101';
    try {
        const ubigeoElement = $('#enova-carrito-block-despacho-shipping__distrito option:selected');
        if (ubigeoElement.length && ubigeoElement.data('ubigeo')) {
            ubigeo = ubigeoElement.data('ubigeo').toString();
        }
    } catch (e) {}

    let diasHabilesDesdeHoy = 1;
    const fechaInicio = new Date(hoy);
    const diaHoy = hoy.getDay(); 

    const diasAntesDeCorte = { 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 2, 0: 2 };
    const diasDespuesDeCorte = { 1: 2, 2: 2, 3: 3, 4: 2, 5: 4, 6: 3, 0: 2 };

    const mapa = horaActual >= horarioCorte ? diasDespuesDeCorte : diasAntesDeCorte;
    fechaInicio.setDate(fechaInicio.getDate() + mapa[diaHoy]);

    const diasValidos = [];
    const temp = new Date(fechaInicio);
    const nombres = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    while (diasValidos.length < 7) {
        const d = temp.getDay();
        if (d !== 0 && !esFeriado(temp)) {
            diasValidos.push({
                fecha: formatDateToDDMMYYYY(temp),
                dia: nombres[d]
            });
        }
        temp.setDate(temp.getDate() + 1);
    }

    diasValidos.forEach(({ fecha, dia }) => {
        const opt = document.createElement('option');
        opt.value = fecha;
        opt.textContent = `${dia}, ${fecha}`;
        inputFecha.appendChild(opt);
    });

    function formatDateToDDMMYYYY(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${d}-${m}-${y}`;
    }
}


/* -------------------------------------------------------------------------
 * 4. UI / DOM UPDATES
 * ------------------------------------------------------------------------- */
function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled");
    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled");
    }
}

function checkoutButtonLoader(status) {
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'none');
        jQuery("#enova_cart-data-submit").css("opacity", '.5');
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'initial');
        jQuery("#enova_cart-data-submit").css("opacity", '1');
    }
}

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione</option>`;
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function setSelectorOptions(scope, optionList, addressBilling = null) {
    let templateList = '<option>Seleccione...</option>';
    for(let optionUbigeo of optionList) {
        let itemOptionTemplate = `
            <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
        `;
        templateList += itemOptionTemplate;
    }
    
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = '';

    // Obtener ubigeo y hora actual (una sola vez)
    let ubigeo = '';
    try {
        ubigeo = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo").toString();
    } catch (e) {}
    const horaActual = new Date().getHours();

    for (let method of methodsList) {
        let description = method.description || '';
        let methodName = method.name || '';

        // Evaluar display_rules si existen
        if (method.display_rules && method.display_rules.rules && method.display_rules.rules.length > 0) {
            const matchedRule = method.display_rules.rules.find(rule => {
                if (rule.ubigeo_prefix === '*') return true;
                return ubigeo.startsWith(rule.ubigeo_prefix);
            });

            if (matchedRule) {
                if (matchedRule.cutoff_hour && matchedRule.before_cutoff && matchedRule.after_cutoff) {
                    description = horaActual < matchedRule.cutoff_hour
                        ? matchedRule.before_cutoff
                        : matchedRule.after_cutoff;
                } else {
                    description = matchedRule.default
                }

                if (matchedRule.override_name) {
                    methodName = matchedRule.override_name;
                }
            }
        }

        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-${method.code}" value="${method.code}">
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-tipo__delivery-label enova-shipping-tipo__delivery--method1">
                    <div class="enova-shipping-method-tag-name-title">
                        <span class="enova-shipping-method-title">${methodName} </span>
                        <span class="enova-shipping-method-cost">
                            ${method.is_free_shipping ? 'Gratis' : `S/ ${method.price}`}
                        </span>
                    </div>
                    <div class="enova-shipping-method-tag-description">
                        <p>${description}</p>
                    </div>
                </label>
            </div>
        `;
        templateList += templateItem;
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList);
    calculateShippingMethodToShowOption();
}

function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
            </labe>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `;

    if(document.querySelector(".cart__recap")) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart;
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart);
    }

    // Inicializar evento principal de Submit Checkout
    const submitBtn = document.querySelector("#enova_cart-data-submit");
    if(submitBtn) {
        submitBtn.addEventListener("click", handleCheckoutSubmit);
    }

    // terms y condiciones extra (oculto en este if false)
    let templateTermsCondicions = `
        <div class="enova_terms_conditions_block">
            <input type="checkbox" id="terms_conditions"/>
            <p>He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
        </div>
    `;

    if(!(jQuery(".enova_terms_conditions_block") && jQuery(".enova_terms_conditions_block")[0]) && false) {
        document.querySelector(".cart__recap").innerHTML += templateTermsCondicions;
    }
}


/* -------------------------------------------------------------------------
 * 5. EVENTOS DE FORMULARIOS
 * ------------------------------------------------------------------------- */
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        console.log("button item", buttonDespachoOption);
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked");
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho]:checked")) {
                if( document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda' ) {
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("active");
                    document.querySelector("#enova-despacho-shipping").classList.remove("active");
    
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled");
                    document.querySelector("#enova-despacho-shipping").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "none");
                    $("#enova-despacho-recojo-tienda").css("display", "block");

                    getPickUpShopList();

                    if( document.querySelector("#enova-despacho-delivery-select-fecha") ) {
                        document.querySelector("#enova-despacho-delivery-select-fecha").value = null;
                    }
                    if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                        document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true;
                    }

                } else if ( document.querySelector("input[name=enova-despacho]:checked").value === 'delivery' ) {
                    document.querySelector("#enova-despacho-shipping").classList.add("active");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active");
    
                    document.querySelector("#enova-despacho-shipping").classList.remove("disabled");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "block");
                    $("#enova-despacho-recojo-tienda").css("display", "none");
                    
                    if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                        document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active");
                    }
                    if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                        document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                    }
                }
                // add class hover active
                document.querySelector("input[name=enova-despacho]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        console.log("button item", buttonDespachoOption);
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked 2");
            
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-billing-doc]:checked")) {
                if( document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' ) {
                    document.querySelector("#enova-billing-doc").classList.add("active");
                    document.querySelector("#enova-billing-doc").classList.remove("disabled");

                    if (document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda') {
                        jQuery("#formulario--billing-address_checkbox").prop("checked", false);
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none");
                    }
        
                } else if ( document.querySelector("input[name=enova-billing-doc]:checked").value === 'boleta' ) {
                    document.querySelector("#enova-billing-doc").classList.remove("active");
                    document.querySelector("#enova-billing-doc").classList.add("disabled");

                    jQuery("#formulario--billing-address_checkbox").prop("checked", true);
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block");
                }
                document.querySelector("input[name=enova-billing-doc]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        console.log("button item", buttonDespachoOption);
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked tienda");
            
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active");
                }
                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                }
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        console.log("event select changed", ev.target.value);
        let filter_store_selected = ev.target.value;
        getPickUpShopList(filter_store_selected);
    });
}

function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
            
             $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");
             despachoMethodShippingLoading('loading');

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {
                getTotalCart(true)
                    .then((totalCart) => {

                        despachoMethodShippingLoading('loading');
                        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo"); 
                        let totalWeight = 0
                        
                        let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&total_cart=${totalCart}`;
                        console.log("CARRITO FINAL urlBuilder", urlBuilder);

                        if(SelectedDepartamentoUBIGEO) {
                            fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
                                method: 'GET',
                                headers:{ 'Content-Type': 'application/json' }
                            })
                            .then(res => res.json())
                            .then(response => {
                                console.log('Success:', response);
                                SetRenderShippingMethodsListOption(response);

                                if (getCustomerData("shippingMethodType")) {
                                    let shippingMethodType = getCustomerData("shippingMethodType");
                                    $(`input[name="enova-despacho-tipo"][value="${shippingMethodType}"]`).prop('checked', true).trigger('change');
                                    //if (shippingMethodType == "programmed" && shippingMethodType == $('input[name="enova-despacho-tipo"]:checked').val()) {
                                    //    $(".enova-carrito-block-despacho-shipping__fecha").css("display", "flex");
                                    //}
                                }
                                despachoMethodShippingLoading(null);
                            })
                            .catch(error => {
                                console.error('Error:', error);
                                despachoMethodShippingLoading(null);
                            });
                        } else {
                            alert("Debe seleccionar un Distrito Valido");
                        }

                    })
                    .catch((err) => {
                        console.log("err", err);
                        despachoMethodShippingLoading(null);
                    });
    
            } else {
                despachoMethodShippingLoading(null);
            }
        });
    }
}

function calculateShippingMethodToShowOption() {
    for(let methodOption of document.querySelectorAll("input[name=enova-despacho-tipo]")) {
        methodOption.addEventListener("change", (ev) => {
            console.log("label click");
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");

                if( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-normal") {
                    // none
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "programmed" ) {
                    console.log("label programado");
                    //document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.add("active");
                    //$(".enova-carrito-block-despacho-shipping__fecha").css("display", "flex");
                    //setLogistictProgrammedDateRules();

                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-express" ) {
                    // none
                } else {
                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                }
            }
        });
    }
}

function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("");
        $("p.text-has-error.text-typedoc").remove();
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
    });

    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        let input_doc_type_selected = jQuery("#enova-billing-documento-type").val();
        let currentLength = ev.currentTarget.value.length;
        let regex;

        if(input_doc_type_selected === "1") {
            regex = /^[0-9]$/; 
            if (currentLength >= 8) ev.preventDefault(); 
        } else if(input_doc_type_selected === "2") {
            regex = /^[a-zA-Z0-9]$/; 
            if (currentLength >= 12) ev.preventDefault(); 
        } else if(input_doc_type_selected === "3") {
            regex = /^[0-9]$/; 
            if (currentLength >= 11) ev.preventDefault(); 
        } else {
            return; 
        }

        if (!regex.test(ev.key)) {
            ev.preventDefault(); 
        }
    });

    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    $("[for='enova-billing-telefono']").text("Celular");
}

function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1");
    if (buttonCartCheckoutStep) {
        buttonCartCheckoutStep.addEventListener("click", (ev) => {
            console.log("eveneto click");
            let blockCartStep = document.querySelector(".enova-block-carrito-main");
            let blockCart = document.querySelector("#MinimogCart");
            document.querySelector("input[name=enova-despacho]:first-child").click();
        });
    }
}

function initSetFormDataUbigeosAvailable() {
    setResetSelectorOptions('departaments');
    setResetSelectorOptions('provinces');
    setResetSelectorOptions('distrits');
    setResetSelectorOptions('departaments', true);
    setResetSelectorOptions('provinces', true);
    setResetSelectorOptions('distrits', true);

    populate("departaments", { country: "1", departament: null, district: null })
    .then((result) => {
        let departmentsList = result ;
        setSelectorOptions("departaments", departmentsList);
        setSelectorOptions("departaments", departmentsList, true);
        
        let region = getCustomerData("region");
        if (region) {
            $("#enova-carrito-block-despacho-shipping__departamento").val(region).change();
        }
    })
    .catch((err) => console.log("err ubigeo selector departaments", err));

    // Eventos Shipping Address
    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {
        setResetSelectorOptions('provinces');
        setResetSelectorOptions('distrits');

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => {
            let provincesList = result ;
            setSelectorOptions("provinces", provincesList);

            let city = getCustomerData("city");
            if (city && $("#enova-carrito-block-despacho-shipping__departamento").val() == getCustomerData("region")) {
                $("#enova-carrito-block-despacho-shipping__provincia").val(city).change();
            }
        })
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits');
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => {
            let districtList = result ;
            setSelectorOptions("distrits", districtList);

            let locality = getCustomerData("locality");
            if (locality && $("#enova-carrito-block-despacho-shipping__provincia").val() == getCustomerData("city")) {
                $("#enova-carrito-block-despacho-shipping__distrito").val(locality);
                const distrito = document.querySelector("#enova-carrito-block-despacho-shipping__distrito");
                distrito.dispatchEvent(new Event("change", { bubbles: true }));
                $(`input[name="enova-despacho-tipo"][value="${getCustomerData("shippingMethodType")}"]`).prop('checked', true).trigger('change');
            }
        })
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    // Eventos Billing Address
    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {
        setResetSelectorOptions('provinces', true);
        setResetSelectorOptions('distrits', true);

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => setSelectorOptions("provinces", result, true))
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true);
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => setSelectorOptions("distrits", result, true))
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        console.log("event changed", jQuery(ev.currentTarget));
        if(!jQuery("#formulario--billing-address_checkbox").prop("checked")) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
        }
    });
}


/* -------------------------------------------------------------------------
 * 6. FLUJO DE CHECKOUT
 * ------------------------------------------------------------------------- */
function handleCheckoutSubmit(ev) {
    ev.preventDefault();

    if( !jQuery("#terms_conditions").prop("checked") ) {
        console.log("Carrito checkout not found");
        document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    document.querySelector("#enova-message-carrito").classList.remove("active");
    document.querySelector("#enova-message-carrito").innerHTML = "";
    console.log("Carrito evento click");

    function getDocumentValue(typeDocument) {
        let numberDocument = ""; 
        if(typeDocument === "factura") {
            numberDocument = document.querySelector("#enova-billing-doc-ruc") ? document.querySelector("#enova-billing-doc-ruc").value : "";
        } else {
            numberDocument = document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : "";
        }
        return numberDocument;
    }

    let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

    function getShippingMatch() {
        let addressSelected = document.querySelector("#enova-despacho-direccion").value;
        let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : "";
        return formateAddress;
    }

    var obj_params = {
        attributes: {
            'pais': 'Peru',
            'modalidad despacho': document.querySelector("input[name=enova-despacho]:checked") ? document.querySelector("input[name=enova-despacho]:checked").value : "",
            'departamento': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
            'provincia': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
            'distrito': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
            'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
            'direccion': getShippingMatch(),
            'referencia': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
            'comprobante de pago': type_document,
            'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
            'nombre': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
            'apellido': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
            'telefono': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
            'tipo documento': document.querySelector("#enova-billing-documento-type") ? document.querySelector("#enova-billing-documento-type").value : "",
            'documento identidad': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
        }
    };

    if(document.querySelector("input[name=enova-despacho-tipo]:checked") && document.querySelector("input[name=enova-despacho-tipo]:checked").value === 'programmed') {
        obj_params['attributes']['fecha de envio'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
        obj_params['attributes']['horario de recojo'] = document.querySelector("#enova-despacho-delivery-select-horario").value;
    }

    if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
        obj_params['attributes']['ruc'] = document.querySelector("#enova-billing-doc-ruc").value;
        obj_params['attributes']['razon social'] = document.querySelector("#enova-billing-doc-razonsocial").value;
    }

    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
        obj_params.attributes['tipo de envio'] = document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '';
    }
    
    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
        obj_params.attributes['departamento'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.departamento : '';
        obj_params.attributes['provincia'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.provincia : '';
        obj_params.attributes['distrito'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.distrito : '';
        obj_params.attributes['ubigeo'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.ubigeo : '';
        obj_params.attributes['direccion'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? `Recojo Tienda: ${jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-direccion").text()}` : "";
        obj_params.attributes['referencia'] = '-';
        obj_params.attributes['tienda recojo'] = jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-titulo").text() : '';

        if( obj_params && obj_params.attributes && obj_params.attributes['fecha de recojo'] && obj_params.attributes['horario de recojo'] ) {
            obj_params.attributes['referencia'] = `Fecha: ${obj_params.attributes['fecha de recojo']}, Horario: ${obj_params.attributes['horario de recojo']}`;
        }
    }

    // validate billing address (empty object for now in original code)
    if( document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' && !jQuery("#formulario--billing-address_checkbox").prop("checked") ) {
        // ... (Atributos de facturación mantenidos vacíos como en el original) ...
    }

    // ==========================================
    // CONFIGURACIÓN Y LISTAS DE CAMPOS (VALIDACIÓN)
    // ==========================================
    let formValid = true;
    const fieldsCommon = ['nombre', 'apellido', 'email', 'telefono', 'tipo documento', 'documento identidad', 'pais', 'modalidad despacho', 'comprobante de pago'];
    const fieldsDelivery = [...fieldsCommon, 'departamento', 'provincia', 'distrito', 'ubigeo', 'direccion', 'referencia', 'tipo de envio'];
    const fieldsPickup   = [...fieldsCommon];

    const dispatchMode = obj_params.attributes['modalidad despacho'] || 'delivery'; 
    const fieldsToValidate = (dispatchMode === 'recojo-tienda') ? fieldsPickup : fieldsDelivery;

    const $inputPhone     = $("#enova-billing-telefono");
    const $selectDocType  = $("#enova-billing-documento-type"); 
    const $inputDocNum    = $("#enova-billing-documento-number");
    const $msgContainer   = $("#enova-message-carrito");
    const $radioFactura   = $('input[name="enova-billing-doc"]:checked');
    const $inputRucFactura= $('#enova-billing-doc-ruc');

    $msgContainer.removeClass("active").text("");
    $inputDocNum.removeClass("input-has-error");
    $(".text-has-error.text-typedoc").remove();

    fieldsToValidate.forEach(key => {
        let value = obj_params.attributes[key];
        if (!value || value.trim() === '') {
            console.log("Campo obligatorio vacío:", key);
            formValid = false;
        }
    });

    if ($inputPhone.val().length < 9) {
        console.log("Error: Teléfono muy corto");
        formValid = false;
    }

    const docType = $selectDocType.val(); 
    const docNum  = $inputDocNum.val();
    const docLen  = docNum.length;
    let docMessage = "";
    let isDocValid = true;

    if (docType === "dni") { 
        if (docLen !== 8 || isNaN(docNum)) {
            docMessage = "El DNI debe tener 8 dígitos numéricos.";
            isDocValid = false;
        }
    } else if (docType === "ce") { 
        const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(docNum);
        if (docLen < 8 || docLen > 12 || !isAlphanumeric) {
            docMessage = "El Carnet de Extranjería debe tener entre 8 y 12 caracteres alfanuméricos.";
            isDocValid = false;
        }
    } else if (docType === "ruc") { 
        if (docLen !== 11 || isNaN(docNum)) {
            docMessage = "El RUC debe tener 11 dígitos numéricos.";
            isDocValid = false;
        }
    }

    if (!isDocValid) {
        formValid = false;
        console.log("Error Documento:", docMessage);
        
        $msgContainer.text(docMessage).addClass("active");
        $inputDocNum.addClass("input-has-error");
        $inputDocNum.parent().append(`<p class='text-has-error text-typedoc'>${docMessage}</p>`);
    }

    if ($radioFactura.val() === "factura") {
        if ($inputRucFactura.val().length !== 11 || isNaN($inputRucFactura.val())) {
            console.log("Error: RUC de Factura inválido");
            $inputRucFactura.addClass("input-has-error");
            formValid = false;
        }
    }

    console.log("Formulario Válido:", formValid);
    console.log("DATA PROCESADA:", obj_params.attributes);
    // ==========================================

    if(formValid) {
        console.log("El formulario correcto datos");

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        checkoutButtonLoader(true);

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },    
            body: JSON.stringify(obj_params)
        })
        .then(response => response.json())
        .then(response => {
            console.log("CART response", response);
            document.querySelector("#enova-message-carrito").classList.remove("active");

            serviceCart2CheckoutStoreFrontAPI(obj_params)
                .then((result) => {
                    console.log("result 1", result);

                    if(result && result.message && result.name === "Error") {
                        console.log("Result es tipo Error", result);
                        checkoutButtonLoader(false);
                        throw result;
                    }
                    
                    if(result && result.checkout && result.checkout.webUrl) {
                        checkoutButtonLoader(true);
                        console.log("PROCESO TERMINADO CHECKOUT", result);
                        setLocalStorageCustomerData();

                        let url_checkout_ = `${result.checkout.id}`;
                        url_checkout_ = `https://ilahuiperu.com/cart/c/${url_checkout_.split("gid://shopify/Cart/")[1]}&channel=buy_button&_fd=0`;

                        const utms = getStoredUTMs();
                        Object.keys(utms).forEach(key => {
                            url_checkout_ += `&${key}=${encodeURIComponent(utms[key])}`;
                        });

                        window.location.href = url_checkout_;
                    } else {
                        throw result;
                    }
                })
                .catch((err) => {
                    console.log("err message final", err);
                    checkoutButtonLoader(false);

                    let message_output = '';
                    let isErrorForm_Retry = false;
                    let jsonErrorObject = null;
                    
                    try { jsonErrorObject = JSON.parse(err.message); } catch(e){}

                    if(jsonErrorObject && jsonErrorObject[0] && jsonErrorObject[0].code === "INVALID" && jsonErrorObject[0].message) {
                        message_output = `Alguno de los campos no son validos: ${jsonErrorObject[0]['message']}`;
                        isErrorForm_Retry = true;
                    } else {
                        message_output= "No se pudo crear el pedido, algunos de los productos no estan disponible. Volver a intentar...";
                        isErrorForm_Retry = false;
                    }

                    checkoutButtonLoader(false);
                    document.querySelector("#enova-message-carrito").textContent = message_output;
                    document.querySelector("#enova-message-carrito").classList.add("active");

                    isErrorForm_Retry = true; // Fallo el pre-checkout, redirect to checkout normal

                    if(!isErrorForm_Retry) {
                        fetch(window.Shopify.routes.root + 'cart.js', {
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' }
                          })
                          .then(response => response.json())
                          .then(response => {
                            console.log("RESPONSE", response.token);
                            window.location.href = `https://ilahuiperu.com/checkouts/cn/${response.token}`;
                          })
                          .catch((err) => {
                            console.log("Fallo segunda redireccion", err);
                            document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos productos no estan disponibles, porfavor vuelve a intentar";
                            document.querySelector("#enova-message-carrito").classList.add("active");
                          });
                    }
                });
        })
        .catch((error) => {
            console.error('CART Error:', error);
        });

    } else {
        console.log("El formulario falta datos");

        // Add class for error border
        if (obj_params.attributes.email === "") document.querySelector("#enova-billing-email").classList.add("input-has-error");
        else document.querySelector("#enova-billing-email").classList.remove("input-has-error");
        
        if (obj_params.attributes.nombre === "") document.querySelector("#enova-billing-name").classList.add("input-has-error");
        else document.querySelector("#enova-billing-name").classList.remove("input-has-error");
        
        if (obj_params.attributes.apellido === "") document.querySelector("#enova-billing-lastName").classList.add("input-has-error");
        else document.querySelector("#enova-billing-lastName").classList.remove("input-has-error");
        
        if (obj_params.attributes.telefono === "") {
          document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
          if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
        } else {
          if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
            document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
            if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
          } else {
            document.querySelector("#enova-billing-telefono").classList.remove("input-has-error");
            $("p.text-has-error.text-phone").remove();
          }
        }

        if (obj_params.attributes["tipo documento"] === "") {
          document.querySelector("#enova-billing-documento-type").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-type").classList.remove("input-has-error");
        }

        if (obj_params.attributes["documento identidad"] === "") {
          document.querySelector("#enova-billing-documento-number").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
          if(typeof validateDocumentTypeForm === "function") validateDocumentTypeForm();
        }
        
        if (obj_params.attributes["tipo de envio"] === "") {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error");
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error");
        }

        if (obj_params.attributes["modalidad despacho"] === "delivery") {
          if (obj_params.attributes.direccion === "") document.querySelector("#enova-despacho-direccion").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error");
          
          if (obj_params.attributes.referencia === "") document.querySelector("#enova-despacho-referencia").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error");
          
          if (obj_params.attributes.departamento === "Seleccione...") document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.remove("input-has-error");
          
          if (obj_params.attributes.provincia === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.remove("input-has-error");
          
          if (obj_params.attributes.distrito === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.remove("input-has-error");
        }

        if( document.querySelector("input[name=enova-despacho]:checked") ) {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`);
            }
        }

        if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`);
            }
        }

        if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0] ) {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show();
            } else {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`);
            }
        }

        if (typeof isCompanyRucValid !== 'undefined' && isCompanyRucValid) {
            document.querySelector("#enova-billing-doc-ruc").classList.remove("input-has-error");
            $("#enova-billing-documento-number").parent().append(`<p class='text-has-error text-typedoc'></p>`);
        } else if (jQuery('input[name="enova-billing-doc"]:checked').val() === "factura") {
            document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error");
            var message_validation = "El campo N de RUC debe tener 11 dígitos";
            if ($("#enova-billing-doc-ruc").parent().find('.text-has-error').length === 0) {
                $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`);
            }
        }

        if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
            if ( jQuery("#enova-billing-doc-razonsocial").val() === "" ) {
                document.querySelector("#enova-billing-doc-razonsocial").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-billing-doc-razonsocial").classList.remove("input-has-error");
            }
        }

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo";
        document.querySelector("#enova-message-carrito").classList.add("active");
    }
}


/* -------------------------------------------------------------------------
 * 7. INICIALIZADOR
 * ------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
    setFormDespacho();
    setFormBillingDoc();
    setStoresEventClick();
    calculateShippingMethodByUbigeoSelected();
    calculateShippingMethodToShowOption();
    setRenderCartFormKeypressValidation();
    cartStep1();
    
    setLogistictProgrammedDateRules();
    setInitCustomerData();
});

$('#enova-carrito-block-despacho-shipping__distrito').change(function() {
    setLogistictProgrammedDateRules();
});

var setCheckerCartDiscountLabel = setInterval(() => {
    if (window.location.href.includes("cart") && !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart();
        clearInterval(setCheckerCartDiscountLabel); // <-- Detener el loop

        getResponseCartItems(true)
            .then((carritoItemsListE) => {
                console.log("CARRITO READY", carritoItemsListE);
                if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                    jQuery(".enova-carrito-block").addClass("active");
                    jQuery("#enova_cart-data-submit").show();
                   jQuery(".enova-carrito-block-seleccion-despacho").hide();
                   jQuery("#despacho-title").hide();
                    jQuery(".enova-carrito-block-despacho-shipping__title").text("Ingrese su dirección de facturación");
                    jQuery(".enova-carrito-block-seleccion-despacho__container #enova-despacho-delivery-option").parent().click();
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active");
                } else {
                    jQuery(".enova-carrito-block").addClass("active");
                    jQuery("#enova_cart-data-submit").show();
                }
            });

        initSetFormDataUbigeosAvailable();
    }
}, 1000);